import React from "react";
import Icon from "components/CommonIcon/Icon";
import ConditionalLink from "components/ConditionalLink";

export const WhatsAppFloat = ({ link }) => {
  return (
    <div className="hidden lg:flex fixed justify-center items-center right-30 bottom-60 z-100 bg-green-wa-light shadow-scroll-up rounded-full h-60 w-60">
      <ConditionalLink link={link}>
        <Icon name="whatsapp" color="text-white" fontSize="text-42" />
      </ConditionalLink>
    </div>
  );
};
